import { StationAssignmentStrategy } from 'src/tmc-yard/common/station-assignment-strategy/station-assignment-strategy.model';
import { TransportScope } from 'src/tmc-yard/common/model/transport.model';

export enum ActionType {
  LOAD = 'LOAD', UNLOAD = 'UNLOAD', LOAD_AND_UNLOAD = 'LOAD_AND_UNLOAD', NONE = 'NONE'
}

export enum RoutingPositionStatus {
  PLANNED = 'PLANNED', RETRIEVED = 'RETRIEVED', CANCELED = 'CANCELED', DONE = 'DONE'
}

export enum StationLevel {
  STATION_GROUP = 'STATION_GROUP', STATION_SET = 'STATION_SET', STATION = 'STATION'
}

export enum StationType {
  WORKING_AREA = 'WORKING_AREA',
  WAITING_AREA = 'WAITING_AREA'
}

export enum TaskRelevance {

  OPTIONAL = 'OPTIONAL',

  /* entrance and leave */
  ON_ENTRANCE = 'ON_ENTRANCE',
  ON_LEAVE = 'ON_LEAVE',

  /* station behaviour */
  BEFORE_RETRIEVE = 'BEFORE_RETRIEVE',
  BEFORE_PROCESSING_STATUS = 'BEFORE_PROCESSING_STATUS',
  AFTER_RETRIEVE = 'AFTER_RETRIEVE',
  BEFORE_FINISH = 'BEFORE_FINISH',

  /* automatisized */
  AUTOMATICALLY_ON_RETRIEVE = 'AUTOMATICALLY_ON_RETRIEVE',
  AUTOMATICALLY_ON_PROCESSING_STATUS = 'AUTOMATICALLY_ON_PROCESSING_STATUS',
  AUTOMATICALLY_ON_COMPLETE_PROCESSING_STATION = 'AUTOMATICALLY_ON_COMPLETE_PROCESSING_STATION',
  AUTOMATICALLY_ON_FINISH_TRANSPORT = 'AUTOMATICALLY_ON_FINISH_TRANSPORT',
  AUTOMATICALLY_ON_ATTACH_TRUCK = 'AUTOMATICALLY_ON_ATTACH_TRUCK',
  AUTOMATICALLY_WHEN_AVAILABLE = 'AUTOMATICALLY_WHEN_AVAILABLE'

}

export class TransportRoutingIdentity {
  id: number;
}

export class RoutingPositionTask {
  id: number;
  relevance: TaskRelevance;
  processingStatus: string;
  done: boolean;

  constructor(task: any) {
    this.id = task.id;
    this.relevance = task.relevance;
    this.processingStatus = task.processingStatus;
    this.done = task.done;
  }
}

export class TransportProfile {
  id: number;
  name: string;
  constructor(transportProfile: any) {
    this.id = transportProfile.id;
    this.name = transportProfile.name;
  }
}


export class TransportRouting {
    id: number;
    identifier: string;
    name: string;
    carrier: string;
    routingPositions: RoutingPosition[] = [];
    deletedRoutingPositions: RoutingPosition[] = [];
    transportProfiles: TransportProfile[] = [];
    useAsShuttle: boolean;
    transportScope: TransportScope;
    reloadRouteEnabled = false;
    changeRouteManually: boolean;

    constructor(transportRouting: any) {
      this.id = transportRouting.id;
      this.identifier = transportRouting.identifier;
      this.name = transportRouting.name;
      this.carrier = transportRouting.carrier;
      this.useAsShuttle = transportRouting.useAsShuttle;
      this.transportScope = transportRouting.transportScope;
      this.reloadRouteEnabled = transportRouting.reloadRouteEnabled;
      this.changeRouteManually = transportRouting.changeRouteManually;
      if (transportRouting.routingPositions != null) {
        transportRouting.routingPositions.forEach(routingPosition => this.routingPositions.push(new RoutingPosition(routingPosition)));
      }
      if (transportRouting.deletedRoutingPositions != null) {
        transportRouting.deletedRoutingPositions.forEach(routingPosition => this.deletedRoutingPositions.push(new RoutingPosition(routingPosition)));
      }
      if (transportRouting.transportProfiles != null) {
        transportRouting.transportProfiles.forEach(profile => this.transportProfiles.push(new TransportProfile(profile)));
      }
    }
}
export class RoutingPosition {
  id: number;
  index: number;
  stationId: number;
  stationName: string;
  stationType: StationType;
  actionType: ActionType;
  cargo: string;
  routingPositionStatus: RoutingPositionStatus;
  stationLevel: StationLevel;
  waitingForRetrieve: boolean;
  cargoMandatory: boolean;
  tasks: RoutingPositionTask[] = [];
  predictedDuration: number;
  routingRuleId: number;
  hint: string;
  processingStatusModel: string;
  stationAssignmentStrategy: StationAssignmentStrategy;

  constructor(routingPosition: any) {
    this.id = routingPosition.id;
    this.index = routingPosition.index;
    this.stationId = routingPosition.stationId;
    this.stationName = routingPosition.stationName;
    this.stationType = routingPosition.stationType;
    this.actionType = routingPosition.actionType;
    this.cargo = routingPosition.cargo;
    this.routingPositionStatus = routingPosition.routingPositionStatus;
    this.stationLevel = routingPosition.stationLevel;
    this.waitingForRetrieve = routingPosition.waitingForRetrieve;
    this.cargoMandatory = routingPosition.cargoMandatory;
    if (routingPosition.tasks != null) {
      routingPosition.tasks.forEach(task =>
        this.tasks.push(new RoutingPositionTask(task))
      );
    }
    this.predictedDuration = routingPosition.predictedDuration;
    this.routingRuleId = routingPosition.routingRuleId;
    this.hint = routingPosition.hint;
    this.processingStatusModel = routingPosition.processingStatusModel;
    this.stationAssignmentStrategy = routingPosition.stationAssignmentStrategy;
  }

}

export class Route {
  changeRouteManually = false;
  routingPositions: RoutingPosition[] = [];

  constructor(route: any) {
    this.changeRouteManually = route.changeRouteManually;
    if (route.routingPositions != null) {
      route.routingPositions.forEach(position => this.routingPositions.push(new RoutingPosition(position)));
    }
  }
}
